import { SET_REPORTING_CONFIG } from '../types/reporting'

import { getReportingConfigAPI, updateReportingConfigAPI } from '../api/reporting'

import { addMessageCurry, commonActionAPIHit } from '../utils/api'

export const setReportingConfig = (payload) => ({
  type: SET_REPORTING_CONFIG,
  payload,
})

export const getReportingConfig = (groupName) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getReportingConfigAPI(groupName), dispatch).then((res) => {
        dispatch(setReportingConfig(res))
        resolve(res)
      })
    })
  }
}

export const updateReportingConfig = (data, groupName) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(updateReportingConfigAPI(data, groupName), dispatch).then((data) => {
        resolve(data)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/reporting.js